import $ from 'jquery';

Drupal.behaviors.header = {
  attach() {
    $('.hamburger-icon').on('click', () => {
      $('.header-menu-item-wrapper').toggleClass('display-header');
      $('button.ui-hamburger-02').toggleClass('header-active');
    });
    $('.defaultheader .mobile-search-btn').on('click', () => {
      if ($('.mobile-search-btn').hasClass('active')) {
        $('.mobile-search-btn').removeClass('active');
        $('.mobile-search-input').slideUp();
      } else {
        $('.mobile-search-btn').addClass('active');
        $('.mobile-search-input').slideDown();
      }
    });
    $('.header-menu-wrapper .header-menu-item-wrapper .search-wrapper input').on('click', (e) => {
      $('.search-widget-wrapper').addClass('display-serach-widget');
      $('.header-menu-wrapper .header-menu-item-wrapper .search-wrapper').addClass('search-close-btn');
      $('.header-menu-wrapper .header-menu-item-wrapper .search-wrapper .form-text').addClass('hide-search-wrapper');
      $('.header-menu-wrapper .header-menu-item-wrapper .getlegalhelpbutton-wrapper').addClass('hide-search-wrapper');
      $('.header-menu-wrapper .mainnavigation-wrapper').addClass('hide-search-wrapper');
      $('.header-menu-wrapper .secondary-gtranslate-wrapper').addClass('hide-search-wrapper');
      $('.search-widget-wrapper input').focus();
      $('body').addClass('search-widget-wrapper-styling');
      $('body').append('<div class="search-overlay"></div>');
      $('.search-overlay').height(document.body.scrollHeight);
      e.stopPropagation();
    });
    $('.header-menu-wrapper .header-menu-item-wrapper .search-wrapper').on('click', () => {
      $('.search-widget-wrapper').removeClass('display-serach-widget');
      $('.header-menu-wrapper .header-menu-item-wrapper .search-wrapper').removeClass('search-close-btn');
      $('.header-menu-wrapper .header-menu-item-wrapper .search-wrapper .form-text').removeClass('hide-search-wrapper');
      $('.header-menu-wrapper .header-menu-item-wrapper .getlegalhelpbutton-wrapper').removeClass('hide-search-wrapper');
      $('.header-menu-wrapper .mainnavigation-wrapper').removeClass('hide-search-wrapper');
      $('.header-menu-wrapper .secondary-gtranslate-wrapper').removeClass('hide-search-wrapper');
      $('body').removeClass('search-widget-wrapper-styling');
      $('.search-overlay').remove();
    });

    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode == 27) {//27 is the code for escape
        if ($('.search-widget-wrapper').hasClass('display-serach-widget')) {
          $('.header-menu-wrapper .header-menu-item-wrapper .search-wrapper').trigger('click');
        }
      }
    };

    $('.header-menu-wrapper .search-btn-mobile-wrapper .search-wrapper').on('click', () => {
      $('.search-widget-wrapper').toggleClass('display-serach-widget');
      $('.header-menu-wrapper .search-btn-mobile-wrapper .search-wrapper').toggleClass('search-close-btn');
      $('.header-menu-wrapper .search-btn-mobile-wrapper .search-wrapper .form-text').toggleClass('hide-search-wrapper');
      $('.header-menu-wrapper .hamburger-icon').toggleClass('hide-search-wrapper');
      // $('.header-menu-wrapper .header-menu-item-wrapper .getlegalhelpbutton-wrapper').toggleClass('hide-search-wrapper');
      // $('.header-menu-wrapper .mainnavigation-wrapper').toggleClass('hide-search-wrapper');
      // $('.header-menu-wrapper .secondary-gtranslate-wrapper').toggleClass('hide-search-wrapper');
    });
    // $('body .header-menu-wrapper .search-widget-wrapper .search-wrapper').on('click', () => {
    //   $('body main.main-content').toggleClass('overlay');
    // })
    $('.header-menu-wrapper .hamburger-icon').on('click', function() {
      $('.header-menu-wrapper .search-btn-mobile-wrapper').toggleClass('hide-search-wrapper');
    });
    $('.nlevel-menu-default-wrapper.expand > ul').hide();

    $('.nlevel-menu-default-wrapper.expand > .menu-arrow').click(function(e){
      e.preventDefault();
      if($( window ).width() >= 1024) {
        $(this).parent().siblings('.menu-open').removeClass('menu-open');
      }
      $(this).parent().toggleClass('menu-open');
    });
    if($( window ).width() >= 1280) {
      $(".nlevel-menu-default-wrapper.expand").hover(function(){
        $(this).addClass("menu-open");
      }, function(){
        $(this).removeClass("menu-open");
      });
    }   
  },
};

